import moment from 'moment'
import {
  getCount
} from '~api/counter'

const delay = {
  quick: 1000,
  normal: 3000,
  slow: 5000,
  'super-slow': 10000,
  manual: 0
}

export const state = () => ({
  modalOpen: false,
  modalBackdrop: false,
  toasts: [],
  loaderState: '',
  pageInitialState: '',
  uniqueVisitorCount: 0,
  showPageLoader: false
})

export const getters = {
  isModalOpen: state => state.modalOpen,
  toastsGetter: state => state.toasts,
  uniqueVisitorCountGetter: state => state.uniqueVisitorCount,
  showPageLoaderGetter: state => state.showPageLoader
}

export const actions = {
  resetModal ({ commit }) {
    commit('setModalClose')
    commit('setModalBackdropClose')
  },
  togglePageLoader ({ commit, dispatch }, isActive) {
    commit('setPageLoader', isActive)
  },
  toggleBackDrop ({ commit }, isActive) {
    isActive ? commit('setModalBackdropOpen') : commit('setModalBackdropClose')
  },
  toggleModal ({ commit, state, dispatch }, nextModalAction) {
    if (nextModalAction !== state.modal) {
      commit('setModalToggle')
      if (nextModalAction) {
        commit('setModalBackdropOpen')
        setTimeout(() => {
          window.$('body>.modal-backdrop').on('click', function () {
            dispatch('resetModal')
          })
        }, 500)
      } else {
        commit('setModalBackdropClose')
      }
    }
  },
  newToast ({ commit }, toast) {
    const _delay = delay[toast.speed || 'slow']
    const publishedAt = moment().format('X')
    commit('setToast', { ...toast, ...{ published_at: publishedAt }, delay: _delay })
    if (_delay > 0) {
      setTimeout(() => {
        commit('removeToast', publishedAt)
      }, _delay + 1000)
    }
  },
  async getUniqueVisitorCount ({ commit }) {
    const count = await getCount()
    commit('setUniqueVisitorCount', count)
    return count
  }
}
export const mutations = {
  setLoaderState (state, payload) {
    state.loaderState = payload
  },
  setPageInitialState (state, payload) {
    state.pageInitialState = payload
  },
  setModalOpen (state) {
    state.modalOpen = true
  },
  setModalClose (state) {
    state.modalOpen = false
  },
  setModalToggle (state) {
    state.modalOpen = !state.modalOpen
  },
  setModalBackdropOpen (state) {
    state.modalBackdrop = true
    window.$('body').addClass('modal-open').append('<div class="modal-backdrop fade show"></div>')
  },
  setModalBackdropClose (state) {
    state.modalBackdrop = false
    window.$('body').removeClass('modal-open')
    window.$('body>.modal-backdrop').remove()
  },
  setToast (state, payload) {
    state.toasts.push(payload)
  },
  removeToast (state, payload) {
    const index = state.toasts.findIndex(toast => toast.published_at === payload)
    state.toasts.splice(index, 1)
  },
  setUniqueVisitorCount (state, payload) {
    state.uniqueVisitorCount = payload
  },
  setPageLoader (state, payload) {
    state.showPageLoader = payload
  }
}
